import React, { useEffect } from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="privacy-page">
      <div className="privacy-decor-circle privacy-decor-1"></div>
      <div className="privacy-decor-circle privacy-decor-2"></div>
      <div className="container">

        {/* Header */}
        <div className="privacy-header">
          <span className="privacy-badge">Legal Policy</span>
          <h1 className="privacy-title">Privacy Policy</h1>
          <p className="privacy-subtitle">
            Last Updated: June 2026. Your privacy and trust are paramount to us. Learn how we protect and handle your personal data.
          </p>
        </div>

        {/* Content Card */}
        <div className="privacy-content-card">
          <div className="privacy-section">
            <h2>1. Introduction</h2>
            <p>
              Welcome to <strong>EduITalent</strong> (referred to as "we", "us", "our", or the "Company"). We respect your privacy and are committed to protecting your personal data. This Privacy Policy describes how we collect, use, process, and disclose your information, including personal data, when you access and use our website, IT services, and recruitment platforms.
            </p>
            <p>
              By using our website or services, you agree to the collection and use of information in accordance with this policy. If you do not agree with the terms of this policy, please do not access or use our services.
            </p>
          </div>

          <div className="privacy-section">
            <h2>2. Information We Collect</h2>
            <p>
              Depending on whether you are a client looking for IT/recruitment services or a candidate applying for jobs, we may collect the following types of information:
            </p>
            <ul>
              <li><strong>Personal Identifiers:</strong> Name, email address, phone number, physical address, and company name.</li>
              <li><strong>Professional Details:</strong> Resumes, employment history, qualifications, skills, and LinkedIn profiles (for job applicants).</li>
              <li><strong>Technical Data:</strong> IP address, browser type, device information, operating system, and details about how you interact with our website.</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h2>3. How We Use Your Information</h2>
            <p>
              We process your personal information for purposes based on legitimate business interests, the fulfillment of our services, compliance with legal obligations, and/or consent. We use the information we collect to:
            </p>
            <ul>
              <li>Provide, operate, and maintain our IT consulting, software development, and recruitment services.</li>
              <li>Process job applications, evaluate candidate qualifications, and coordinate interviews with prospective employers.</li>
              <li>Communicate with clients and candidates regarding updates, service inquiries, and business transactions.</li>
              <li>Improve, personalize, and expand our website functionality and user experience.</li>
              <li>Monitor and analyze usage trends to protect against fraudulent activities and ensure compliance with our terms of service.</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h2>4. Data Sharing and Disclosure</h2>
            <p>
              We do not sell, trade, or rent your personal identification information to third parties. We may share information under the following circumstances:
            </p>
            <ul>
              <li><strong>With Prospective Employers:</strong> If you are a candidate, we share your professional qualifications and resume details with prospective employers after receiving your consent.</li>
              <li><strong>With Service Providers:</strong> We may share data with trusted third-party providers who perform services on our behalf (e.g., payroll processing, hosting, and website analytics).</li>
              <li><strong>For Legal Compliance:</strong> We may disclose information if required to do so by law or in response to valid requests by public authorities.</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h2>5. Data Security</h2>
            <p>
              We implement appropriate technical and organizational security measures designed to protect the security of any personal information we process. However, please remember that no method of transmission over the Internet, or method of electronic storage, is 100% secure. While we strive to use commercially acceptable means to protect your personal data, we cannot guarantee its absolute security.
            </p>
          </div>

          <div className="privacy-section">
            <h2>6. Your Data Rights</h2>
            <p>
              Depending on your location, you may have rights under applicable data protection laws, including:
            </p>
            <ul>
              <li>The right to request access to and obtain a copy of your personal data.</li>
              <li>The right to request rectification (correction) of inaccurate or incomplete personal data.</li>
              <li>The right to request the deletion of your personal data, subject to certain legal exceptions.</li>
              <li>The right to withdraw your consent to data processing at any time.</li>
            </ul>
            <p>
              To exercise any of these rights, please contact us at <a href="mailto:info@eduitalent.com">info@eduitalent.com</a>.
            </p>
          </div>

          <div className="privacy-section">
            <h2>7. Contact Us</h2>
            <p>
              If you have any questions or concerns about this Privacy Policy or our data practices, please contact us:
            </p>
            <div className="privacy-contact-info">
              <p><strong>EduITalent</strong></p>
              <p>Email: <a href="mailto:info@eduitalent.com">info@eduitalent.com</a></p>
              <p>India Office: Noida, UP, India</p>
              <p>Globe Office: Business Bay, Globe</p>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default PrivacyPolicy;
